type GarbageProps = {
  [key: string]: string;
};

export const GARBAGES: GarbageProps = {
  MIXED: "Zmieszane",
  GLASS: "Szkło",
  BIO: "Bioodpady",
  PAPER: "Papier",
  PLASTIC: "Metale i tworzywa sztuczne",
  TREE: "Drzewka świąteczne",
  BIG: "Odpady wystawkowe",
} as const;

// Modern 2024/2025 design tokens
export const THEME = {
  // Border radius - more rounded, softer look
  borderRadius: "1rem",
  borderRadiusSm: "0.625rem",
  borderRadiusLg: "1.25rem",
  borderRadiusXl: "1.5rem",
  borderRadiusFull: "9999px",
  
  // Spacing
  spacingXs: "0.25rem",
  spacingSm: "0.5rem",
  spacingMd: "1rem",
  spacingLg: "1.5rem",
  spacingXl: "2rem",
  
  // Transitions
  transitionFast: "150ms cubic-bezier(0.4, 0, 0.2, 1)",
  transitionBase: "250ms cubic-bezier(0.4, 0, 0.2, 1)",
  transitionSlow: "350ms cubic-bezier(0.4, 0, 0.2, 1)",
  transitionBounce: "500ms cubic-bezier(0.68, -0.55, 0.265, 1.55)",
} as const;

// Updated, more vibrant garbage colors - modern palette
export const colors: GarbageProps = {
  MIXED: "#374151",    // Modern dark gray
  GLASS: "#10B981",    // Emerald green
  BIO: "#D97706",      // Amber/brown
  PAPER: "#3B82F6",    // Bright blue
  PLASTIC: "#FBBF24",  // Golden yellow
  TREE: "#059669",     // Deep green for trees
  BIG: "#8B5CF6",      // Purple for big items
} as const;

// Gradient versions for special effects
export const gradientColors: GarbageProps = {
  MIXED: "linear-gradient(135deg, #374151 0%, #1F2937 100%)",
  GLASS: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
  BIO: "linear-gradient(135deg, #D97706 0%, #B45309 100%)",
  PAPER: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
  PLASTIC: "linear-gradient(135deg, #FBBF24 0%, #F59E0B 100%)",
  TREE: "linear-gradient(135deg, #059669 0%, #047857 100%)",
  BIG: "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)",
} as const;
